import React, { useContext } from 'react';
import { PlaybackInformationContext } from '../../../../contexts/PlaybackInformationContext';
import { PlaybackSettingsQuality } from './PlaybackSettingsQuality';
import { PlaybackSettingsAudio } from './PlaybackSettingsAudio';
import { PlaybackSettingsSubtitle } from './PlaybackSettingsSubtitle';
import { PlaybackSettingsAirplay } from './PlaybackSettingsAirplay';
import { PlaybackSettingsCast } from './PlaybackSettingsCast';
import { PlaybackSettingsPip } from './PlaybackSettingsPip';
import { PlaybackSettingsVolume } from './PlaybackSettingsVolume';
import { PlaybackSettingsFullscreen } from './PlaybackSettingsFullscreen';

export const PlaybackSettings: React.FC = () => {
	const { player } = useContext(PlaybackInformationContext);

	if (!player) return null;

	return (
		<div className={'playback-settings'}>
			{/* <PlaybackSettingsQuality /> */}
			<PlaybackSettingsAudio />
			<PlaybackSettingsSubtitle />
			<PlaybackSettingsAirplay />
			<PlaybackSettingsCast />
			<PlaybackSettingsPip />
			<PlaybackSettingsVolume />
			<PlaybackSettingsFullscreen />
		</div>
	);
};
